// Il dialogo rende inerte il sito; chiudiamo anche il ciclo Tab fra i suoi comandi.
export const trapViewerFocus = (event) => {
    if (event.key !== "Tab") return;
    const dialog = event.currentTarget;
    const controls = Array.from(dialog.querySelectorAll(
        'button:not(:disabled), a[href], input:not(:disabled), textarea:not(:disabled), select:not(:disabled), [tabindex]:not([tabindex="-1"])'
    )).filter((element) =>
        element.tabIndex >= 0 && !element.closest('[inert], [aria-hidden="true"]') &&
        element.getClientRects().length && getComputedStyle(element).visibility !== "hidden"
    );
    event.preventDefault();
    event.stopPropagation();
    const current = controls.indexOf(dialog.ownerDocument.activeElement);
    const next = current < 0 ? (event.shiftKey ? controls.length - 1 : 0)
        : (current + (event.shiftKey ? -1 : 1) + controls.length) % controls.length;
    (controls[next] || dialog).focus({ preventScroll: true });
};